import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep" data-id="element-98" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-99" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl text-gold" data-id="element-100" data-mp="3ghc2o28413o8">
          Session Ready <span className="text-white" data-id="element-101" data-mp="32p5lcct80qn7">SLP</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-102" data-mp="36p6aardy4k8i">
          The Stacked Session Method — because a mixed group shouldn&apos;t cost
          you another Sunday night.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-103" data-mp="38h456i9zcjd">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-104" data-mp="3levih6kghoia">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-plum-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-105" data-mp="29zgnu9fpz8qc">
          Session Ready SLP is an educational resource for speech-language
          professionals (SLPs, SLTs, speech pathologists and S-LPs). It
          supports, and does not replace, professional clinical judgment,
          assessment or the individual goals set for each student (IEP, EHCP,
          ILP, IPP or equivalent). Follow the policies of your district, school
          board, employer and professional body. No specific student outcomes
          are promised. Not affiliated with any professional association or
          materials marketplace. © Session Ready SLP 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}